module.exports = __webpack_public_path__ + "img/Card 2.4199e1d1.png";